import React, { forwardRef, useImperativeHandle } from "react";
import { ContainerInput, ContainerPassword, FieldErrorMessage, FormGroup, ImageInput, Input, InputPassword, Label, StyledSpan } from "./styles";
import Eye from "../../assets/images/eye.svg";
import CloseEye from "../../assets/images/closeEye.svg";

const InputCustom = forwardRef(
    (
      {
        id,
        name,
        type,
        description,
        value,
        onChange,
        onBlur,
        isInvalid,
        errors,
        className,
        onClickSpan,
        placeholder,
        textTransform,
        disabled,
        autoComplete,
        defaultValue,
        inputMode,
        maxLength
      },
      ref
    ) => {
    const inputRef = React.useRef(null);
    const [inputError, setInputError] = React.useState("");
    const [applied, setApply] = React.useState(!!defaultValue);
    const [showPassword, setShowPassword] = React.useState(false);
    const [isDisabled, setDisable] = React.useState(disabled || false);
    const [initialized, setInitialized] = React.useState(false);
    const toggleShowPassword = () => setShowPassword(!showPassword);

    React.useEffect(() => {
      if (defaultValue && !initialized && inputRef.current) {
        inputRef.current.value = defaultValue.toUpperCase();
        setDisable(true);
        setApply(true);
        setInitialized(true);
      }
    }, [defaultValue, initialized]);

    useImperativeHandle(ref, () => ({
        triggerResetInput() {
          if (onClickSpan) {
            applyClick();
          }
        },
      }));

    function applyClick(){            
        if(!applied){
            if(inputRef.current?.value && inputRef.current.value !== ''){
                if(onClickSpan)
                    onClickSpan(inputRef.current.value.toUpperCase());

                setInputError("");
                setDisable(true);
                setApply(true);
            }        
            else
                setInputError("Preencha o campo antes de aplicar");
        } else {
            if(onClickSpan)
                onClickSpan('');
            inputRef.current.value = '';
            setDisable(false);
            setApply(false);
        }
    }

    return (
        <FormGroup className={className}>
            {(isInvalid || inputError) ? (
                <FieldErrorMessage>{ inputError !== "" ? inputError : errors}</FieldErrorMessage>
            ) : null}
            <ContainerInput>
                {type === "password" ? (
                    <InputPassword
                        invalid={isInvalid}
                        id={id}
                        type={showPassword ? "text" : "password"}
                        name={name}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                    />
                ) : (
                    <Input
                        invalid={isInvalid}
                        id={id}
                        type={type}
                        name={name}
                        onChange={onChange}
                        onBlur={onBlur}
                        ref={inputRef}
                        value={value}
                        placeholder={placeholder}
                        disabled={isDisabled}
                        style={{textTransform: textTransform}}
                        autoComplete={autoComplete}
                        inputMode={inputMode}
                        maxLength={maxLength}
                    />
                )}
                {type === "password" && (
                    <ImageInput onClick={toggleShowPassword} src={type === "password" && showPassword ? Eye : CloseEye} alt={type === "password" && showPassword ? "Eye" : "CloseEye"} />
                )}
                {type === "apply" && (
                    <StyledSpan onClick={applyClick} className={isDisabled ? "redFont" : ""}>{applied ? "Remover" : "Aplicar"}</StyledSpan>
                )}
            </ContainerInput>
            <Label htmlFor={id}>{description}</Label>
        </FormGroup>
    );
});

export default InputCustom;
